export const title = ({ theme: { colors } }) => ({
    color: colors.text,
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0.3px',
    lineHeight: '31px',
    margin: 0,
});
